import React, { Component } from "react";
import Modal from "components/Modal";
import UserForm, { UserModel } from "./UserForm";
import { Space } from "services/entities/spaces";
import "./index.scss";

interface BookingEnquiryUserModalProps {
  spaces?: Space[] | null;
  open: boolean;
  onCancelled?: () => void;
  onSaved?: (user: UserModel) => void;
  changeSpace?: any;
  space?: string;
}

export default class BookingEnquiryUserModal extends Component<
  BookingEnquiryUserModalProps,
  {}
> {
  render() {
    return (
      <Modal
        open={this.props.open}
        onClosing={this.onClosing}
      >
        <UserForm
          onSaved={this.onSaved}
          spaces={this.props.spaces}
          space={this.props.space}
          changeSpace={this.props.changeSpace}
        />
      </Modal>
    );
  }

  onClosing = () => {
    if (this.props.onCancelled) {
      this.props.onCancelled();
    }
  };

  onSaved = (user: UserModel) => {
    if (this.props.onSaved) {
      this.props.onSaved(user);
    }
  };
}
